import * as setupReducer from "containers/Setup/reducer";
import * as homeReducer from "containers/Home/reducer";

import * as DatasetAPI from "api/DatasetAPI";

const UPDATE_FIELD = "cluster/UPDATE_FIELD";

const initialState = {};

function clusterReducer(state = initialState, action) {
  switch (action.type) {
    case UPDATE_FIELD:
      return {
        ...state,
        [action.id]: {
          ...state[action.id],
          [action.key]: action.data
        }
      };
    default:
      return state;
  }
}

/* Selectors */
export function getBase(state) {
  return state.cluster;
}

export function getCluster(state, id) {
  return getBase(state) ? getBase(state)[id] : undefined;
}

export function getHover(state, id) {
  return getCluster(state, id) ? getCluster(state, id).hover : undefined;
}

export function getSelected(state, id) {
  return getCluster(state, id) ? getCluster(state, id).selected : undefined;
}

/* Actions */
export function updateHover(id, hover) {
  return {
    type: UPDATE_FIELD,
    id: id,
    key: "hover",
    data: hover
  };
}

export function updateSelected(id, selected) {
  return {
    type: UPDATE_FIELD,
    id: id,
    key: "selected",
    data: selected
  };
}

export function initCluster(id) {
  return (dispatch, getState) => {
    const dataset = homeReducer.getDataset(getState(), id);

    const success =
      dataset &&
      dataset.fields &&
      dataset.outcome &&
      dataset.fields[dataset.outcome] &&
      dataset.fields[dataset.outcome].data &&
      dataset.fields[dataset.outcome].data[0]
        ? dataset.fields[dataset.outcome].data[0].value
        : undefined;

    return DatasetAPI.startRulefit(id, success).then((response) =>
      dispatch(homeReducer.updateHasRulefit(dataset.id, true))
    );
  };
}

export default clusterReducer;
